(function () {
  if (window.__customSortDropdownInitialized) return;
  window.__customSortDropdownInitialized = true;

  function closeCustomSort(customSort) {
    if (!customSort) return;

    customSort.classList.remove('is-open');

    const button = customSort.querySelector('.custom-sort__button');

    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }
  }

  function closeAllCustomSorts(except) {
    document.querySelectorAll('[data-custom-sort].is-open').forEach((customSort) => {
      if (except && customSort === except) return;
      closeCustomSort(customSort);
    });
  }

  function openCustomSort(customSort) {
    if (!customSort) return;

    closeAllCustomSorts(customSort);

    const button = customSort.querySelector('.custom-sort__button');

    customSort.classList.add('is-open');

    if (button) {
      button.setAttribute('aria-expanded', 'true');
    }
  }

  function toggleCustomSort(customSort) {
    if (!customSort) return;

    if (customSort.classList.contains('is-open')) {
      closeCustomSort(customSort);
    } else {
      openCustomSort(customSort);
    }
  }

  function selectCustomSortOption(option) {
    const customSort = option.closest('[data-custom-sort]');
    if (!customSort) return;

    const nativeField = customSort.querySelector('.custom-sort__native');
    const buttonText = customSort.querySelector('.custom-sort__text');
    const options = customSort.querySelectorAll('.custom-sort__option');

    if (!nativeField || !buttonText) return;

    const value = option.dataset.value;
    const label = option.textContent.trim();
    const useCase = customSort.dataset.customSortUseCase || 'facets';

    if (!value) return;

    nativeField.value = value;
    buttonText.textContent = label;

    options.forEach((item) => {
      const isSelected = item === option;

      item.classList.toggle('is-selected', isSelected);
      item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    closeCustomSort(customSort);

    nativeField.dispatchEvent(new Event('input', { bubbles: true }));
    nativeField.dispatchEvent(new Event('change', { bubbles: true }));

    customSort.dispatchEvent(
      new CustomEvent('custom-sort:change', {
        bubbles: true,
        detail: {
          value: value,
          label: label,
          useCase: useCase,
          nativeField: nativeField,
        },
      }),
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      const option = event.target.closest('.custom-sort__option');

      if (option) {
        event.preventDefault();
        event.stopPropagation();
        selectCustomSortOption(option);
        return;
      }

      const button = event.target.closest('.custom-sort__button');

      if (button) {
        event.preventDefault();
        event.stopPropagation();

        const customSort = button.closest('[data-custom-sort]');
        toggleCustomSort(customSort);
        return;
      }

      if (!event.target.closest('[data-custom-sort]')) {
        closeAllCustomSorts();
      }
    },
    true,
  );

  document.addEventListener('keydown', function (event) {
    const option = event.target.closest('.custom-sort__option');

    if (option && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      selectCustomSortOption(option);
      return;
    }

    if (event.key === 'Escape') {
      const focusedSort = document.activeElement.closest?.('[data-custom-sort]');
      const button = focusedSort?.querySelector('.custom-sort__button');

      closeAllCustomSorts();

      if (button) {
        button.focus();
      }
    }
  });
})();
